// Decalage du scroll en JS (car header fixe)

document.addEventListener('DOMContentLoaded', function () {
	console.log("Scroll Anchor");

	const header = document.querySelector('.site-header');

	document.querySelectorAll('a[href*="#"]').forEach(anchor => {
		anchor.addEventListener('click', function(e) {

			const url = new URL(this.href);
			const id = url.hash;

			if (!id) return;

			const target = document.querySelector(id);
			if (!target) return;

			e.preventDefault();

			const offset = window.innerWidth < 1024 ? 103 : 127;

			const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

			window.scrollTo({
				top: y,
				behavior: 'smooth'
			});
		});
	});

	window.addEventListener('load', () => {
		if (window.location.hash) {
			const target = document.querySelector(window.location.hash);
			if (!target) return;

			const offset = window.innerWidth < 1024 ? 103 : 127;

			const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

			window.scrollTo({
				top: y,
				behavior: 'smooth'
			});
		}
	});
})
